/* eslint-disable max-len */
const featuredRatingsMock = Array.from({ length: 12 }, (_, index) => ({
  "id": 900000 + index,
  "itemId": 4133465,
  "userId": 1228985,
  "score": index === 11 ? -1 : 1,
  "createdAt": "2025-07-23T22:23:38.000Z",
  "comment": "Clean topology and accurate proportions, it printed without any issues.",
  "authorId": 633755,
  "updatedAt": "2025-07-23T22:23:38.000Z",
  "automatedReview": false,
  "anonymous": false,
  "username": "michambrett",
  "userRole": "buyer",
}))

export const reviewsAreaMockedData = {
  "productId": 4133465,
  "productOwnerUsername": "designer123",
  "commentsCount": 189,
  "comments": [
    {
      "id": 1586355,
      "userId": 166545,
      "content": "It looks really good and the texturing is very realistic, but the models are definitely NOT low poly as stated in the details section. Honestly, sooo many details could have been easily faked by simply baking the high poly mesh onto a texture. There is no need for such mesh details, it is just a colossus waste of performance. I have optimized a few models and they look almost identical to the originals but are far more optimized. If you need some insane close-up renderings of trash then sure this is perfect for that, but other than that I don't know... I wish it was more optimized and actually low poly as promised.",
      "createdAt": "2025-01-25T13:29:02.000Z",
      "updatedAt": "2025-01-25T13:29:02.000Z",
      "ancestry": null,
      "commentableId": 4133465,
      "commentableType": "Item",
      "username": "bcp",
      "userRole": "community_member",
      "avatar": {
        "small": {
          "url": "https://s3.amazonaws.com/cgtimages-staging/avatars/1/small_3b5aec46-9288-4e12-a3ed-279739e05cb4.jpg",
        },
      },
      "replies": [
        {
          "id": 1586356,
          "userId": 633755,
          "content": "Totally agree — the model is super clean.",
          "createdAt": "2025-01-25T14:29:02.000Z",
          "updatedAt": "2025-01-25T14:29:02.000Z",
          "ancestry": "1586355",
          "commentableId": 4133465,
          "commentableType": "Item",
          "username": "carly",
          "userRole": "buyer",
          "avatar": {
            "small": {
              "url": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEsnvkcvGO_36VSBbcMdH1EQkVd6IPZbLlCQ&s",
            },
          },
          "replies": [],
        },
        {
          "id": 1586357,
          "userId": 633756,
          "content": "I agree with the previous comment.",
          "createdAt": "2025-01-25T15:29:02.000Z",
          "updatedAt": "2025-01-25T15:29:02.000Z",
          "ancestry": "1586355",
          "commentableId": 4133465,
          "commentableType": "Item",
          "username": "jessealambert",
          "userRole": "buyer",
          "avatar": {
            "small": {
              "url": "https://e7.pngegg.com/pngimages/78/788/png-clipart-computer-icons-avatar-business-computer-software-user-avatar-child-face-thumbnail.png",
            },
          },
          "replies": [],
        },
      ],
    },
  ],
  "likeCount": 69,
  "dislikeCount": 2,
  "ratings": [
    {
      "id": 861831,
      "avatar": {
        url: "https://s3.amazonaws.com/cgtimages-staging/avatars/1/large_3b5aec46-9288-4e12-a3ed-279739e05cb4.jpg",
      },
      "itemId": 4133465,
      "userId": 1228985,
      "score": 1,
      "createdAt": "2025-07-23T22:23:38.000Z",
      "comment": "",
      "authorId": 633755,
      "updatedAt": "2025-07-23T22:23:38.000Z",
      "automatedReview": false,
      "anonymous": false,
      "username": "michambrett",
      "userRole": "buyer",
    },
    {
      "id": 860225,
      "itemId": 4133465,
      "userId": 845182,
      "score": -1,
      "createdAt": "2025-07-14T05:48:17.000Z",
      "comment": null,
      "authorId": 633755,
      "updatedAt": "2025-07-14T05:48:17.000Z",
      "automatedReview": false,
      "anonymous": false,
      "username": "jessealambert",
      "userRole": "buyer",
    },
  ],
  "featuredRatings": featuredRatingsMock,
  "hasMoreComments": true,
  "hasMoreRatings": true,
  "role": "buyer",
}

reviewsAreaMockedData.featuredComments = Array.from({ length: 3 }, (_, index) => ({
  ...reviewsAreaMockedData.comments[0],
  id: 910000 + index,
}))

export const emptyReviewsAreaMockedData = {
  "productId": 1234567,
  "productOwnerUsername": "designer",
  "commentsCount": 0,
  "comments": [],
  "likeCount": 0,
  "dislikeCount": 0,
  "ratings": [],
  "featuredComments": [],
  "featuredRatings": [],
  "hasMoreComments": false,
  "hasMoreRatings": false,
  "userName": "",
  "role": "buyer",
}
